"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationKey = void 0;
/* istanbul ignore file @preserve */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */
let TranslationKey = exports.TranslationKey = /*#__PURE__*/function (TranslationKey) {
  TranslationKey["Approval_BlockGuaranteeOrdering"] = "Approval_BlockGuaranteeOrdering";
  TranslationKey["Approval_Contact"] = "Approval_Contact";
  TranslationKey["Approval_MarketingConsultant"] = "Approval_MarketingConsultant";
  TranslationKey["Approval_MarketingExternal"] = "Approval_MarketingExternal";
  TranslationKey["Approval_MarketingOriflame"] = "Approval_MarketingOriflame";
  TranslationKey["Approval_Newletters"] = "Approval_Newletters";
  TranslationKey["Approval_PersonalData"] = "Approval_PersonalData";
  TranslationKey["Approval_Publication"] = "Approval_Publication";
  TranslationKey["Approval_UplineLeaderBrowse"] = "Approval_UplineLeaderBrowse";
  TranslationKey["Approval_UplineLeaderData"] = "Approval_UplineLeaderData";
  TranslationKey["BrowserTitle"] = "BrowserTitle";
  TranslationKey["BtnCancel"] = "BtnCancel";
  TranslationKey["BtnLeaving"] = "BtnLeaving";
  TranslationKey["Custom_text"] = "Custom_text";
  TranslationKey["EmailPrimaryChannelDescription"] = "EmailPrimaryChannelDescription";
  TranslationKey["EmailPrimaryChannelLabel"] = "EmailPrimaryChannelLabel";
  TranslationKey["EmailPrimaryChannelPlaceholder"] = "EmailPrimaryChannelPlaceholder";
  TranslationKey["EmailPrimaryChannelTitle"] = "EmailPrimaryChannelTitle";
  TranslationKey["EmailPrimaryChannelTooltip"] = "EmailPrimaryChannelTooltip";
  TranslationKey["EmailVerification_Header"] = "EmailVerification_Header";
  TranslationKey["EmailVerification_ProceedingToRegistration"] = "EmailVerification_ProceedingToRegistration";
  TranslationKey["EmailVerification_SendAgain"] = "EmailVerification_SendAgain";
  TranslationKey["EmailVerification_Text"] = "EmailVerification_Text";
  TranslationKey["EmailVerification_Verified"] = "EmailVerification_Verified";
  TranslationKey["EmailVerification_WrongCode"] = "EmailVerification_WrongCode";
  TranslationKey["Error_WrongCode"] = "Error_WrongCode";
  TranslationKey["FirstStep_Address"] = "FirstStep_Address";
  TranslationKey["FirstStep_Button"] = "FirstStep_Button";
  TranslationKey["FirstStep_Country"] = "FirstStep_Country";
  TranslationKey["FirstStep_Country_Placeholder"] = "FirstStep_Country_Placeholder";
  TranslationKey["FirstStep_Country_Tooltip"] = "FirstStep_Country_Tooltip";
  TranslationKey["FirstStep_DateOfBirth"] = "FirstStep_DateOfBirth";
  TranslationKey["FirstStep_DateOfBirthText"] = "FirstStep_DateOfBirthText";
  TranslationKey["FirstStep_Email"] = "FirstStep_Email";
  TranslationKey["FirstStep_Email_Optional"] = "FirstStep_Email_Optional";
  TranslationKey["FirstStep_FirstName"] = "FirstStep_FirstName";
  TranslationKey["FirstStep_Gender"] = "FirstStep_Gender";
  TranslationKey["FirstStep_Gender_Placeholder"] = "FirstStep_Gender_Placeholder";
  TranslationKey["FirstStep_Header"] = "FirstStep_Header";
  TranslationKey["FirstStep_LastName"] = "FirstStep_LastName";
  TranslationKey["FirstStep_Phone"] = "FirstStep_Phone";
  TranslationKey["FirstStep_PhoneWithPrefix"] = "FirstStep_PhoneWithPrefix";
  TranslationKey["FirstStep_Phone_Optional"] = "FirstStep_Phone_Optional";
  TranslationKey["FirstStep_PlaceHolder"] = "FirstStep_PlaceHolder";
  TranslationKey["FirstStep_PlaceholderEmail"] = "FirstStep_PlaceholderEmail";
  TranslationKey["FirstStep_PlaceholderPhone"] = "FirstStep_PlaceholderPhone";
  TranslationKey["FirstStep_PlaceholderPhoneWithPrefix"] = "FirstStep_PlaceholderPhoneWithPrefix";
  TranslationKey["FirstStep_SearchedAddress"] = "FirstStep_SearchedAddress";
  TranslationKey["FirstStep_Text"] = "FirstStep_Text";
  TranslationKey["FirstStep_TooltipPhone"] = "FirstStep_TooltipPhone";
  TranslationKey["FirstStep_TooltipPhoneWithPrefix"] = "FirstStep_TooltipPhoneWithPrefix";
  TranslationKey["FirstStep_UniqueId"] = "FirstStep_UniqueId";
  TranslationKey["FirstStep_UniqueId_Tooltip"] = "FirstStep_UniqueId_Tooltip";
  TranslationKey["LegalDocument1_Link_Label"] = "LegalDocument1_Link_Label";
  TranslationKey["LegalDocument2_Link_Label"] = "LegalDocument2_Link_Label";
  TranslationKey["LegalDocument3_Link_Label"] = "LegalDocument3_Link_Label";
  TranslationKey["LegalDocument4_Link_Label"] = "LegalDocument4_Link_Label";
  TranslationKey["LegalDocument5_Link_Label"] = "LegalDocument5_Link_Label";
  TranslationKey["LegalDocument6_Link_Label"] = "LegalDocument6_Link_Label";
  TranslationKey["LegalDocument7_Link_Label"] = "LegalDocument7_Link_Label";
  TranslationKey["LegalDocument8_Link_Label"] = "LegalDocument8_Link_Label";
  TranslationKey["ModalLeavigInfo"] = "ModalLeavigInfo";
  TranslationKey["ModalLeavingTitle"] = "ModalLeavingTitle";
  TranslationKey["ParentalConsentCheckboxLabel"] = "ParentalConsentCheckboxLabel";
  TranslationKey["ParentalConsentDescription"] = "ParentalConsentDescription";
  TranslationKey["ParentalConsentEmail"] = "ParentalConsentEmail";
  TranslationKey["ParentalConsentEmailPlaceholder"] = "ParentalConsentEmailPlaceholder";
  TranslationKey["ParentalConsentEmailTooltip"] = "ParentalConsentEmailTooltip";
  TranslationKey["ParentalConsentPendingExplore"] = "ParentalConsentPendingExplore";
  TranslationKey["ParentalConsentPendingPageDescription"] = "ParentalConsentPendingPageDescription";
  TranslationKey["ParentalConsentPendingPageTitle"] = "ParentalConsentPendingPageTitle";
  TranslationKey["ParentalConsentPhone"] = "ParentalConsentPhone";
  TranslationKey["ParentalConsentPhoneWithPrefix"] = "ParentalConsentPhoneWithPrefix";
  TranslationKey["ParentalConsentPlaceholderPhone"] = "ParentalConsentPlaceholderPhone";
  TranslationKey["ParentalConsentSameEmailValidation"] = "ParentalConsentSameEmailValidation";
  TranslationKey["ParentalConsentSamePhoneValidation"] = "ParentalConsentSamePhoneValidation";
  TranslationKey["ParentalConsentTitle"] = "ParentalConsentTitle";
  TranslationKey["ParentalConsentTooltipPhone"] = "ParentalConsentTooltipPhone";
  TranslationKey["ParentalConsentTooltipPhoneWithPrefix"] = "ParentalConsentTooltipPhoneWithPrefix";
  TranslationKey["PhonePrimaryChannelDescription"] = "PhonePrimaryChannelDescription";
  TranslationKey["PhonePrimaryChannelLabel"] = "PhonePrimaryChannelLabel";
  TranslationKey["PhonePrimaryChannelLabelWithPrefix"] = "PhonePrimaryChannelLabelWithPrefix";
  TranslationKey["PhonePrimaryChannelPlaceholder"] = "PhonePrimaryChannelPlaceholder";
  TranslationKey["PhonePrimaryChannelPlaceholderWithPrefix"] = "PhonePrimaryChannelPlaceholderWithPrefix";
  TranslationKey["PhonePrimaryChannelTitle"] = "PhonePrimaryChannelTitle";
  TranslationKey["PhonePrimaryChannelTooltip"] = "PhonePrimaryChannelTooltip";
  TranslationKey["PhonePrimaryChannelTooltipWithPrefix"] = "PhonePrimaryChannelTooltipWithPrefix";
  TranslationKey["PhoneVerification_Header"] = "PhoneVerification_Header";
  TranslationKey["PhoneVerification_ProceedingToRegistration"] = "PhoneVerification_ProceedingToRegistration";
  TranslationKey["PhoneVerification_SendAgain"] = "PhoneVerification_SendAgain";
  TranslationKey["PhoneVerification_Text"] = "PhoneVerification_Text";
  TranslationKey["PhoneVerification_Verified"] = "PhoneVerification_Verified";
  TranslationKey["PhoneVerification_WrongCode"] = "PhoneVerification_WrongCode";
  TranslationKey["Prestep_Apple"] = "Prestep_Apple";
  TranslationKey["Prestep_Button"] = "Prestep_Button";
  TranslationKey["Prestep_Email"] = "Prestep_Email";
  TranslationKey["Prestep_ExternalAccountAlreadyConnected"] = "Prestep_ExternalAccountAlreadyConnected";
  TranslationKey["Prestep_Facebook"] = "Prestep_Facebook";
  TranslationKey["Prestep_Google"] = "Prestep_Google";
  TranslationKey["Prestep_Header"] = "Prestep_Header";
  TranslationKey["Prestep_InvitationCode"] = "Prestep_InvitationCode";
  TranslationKey["Prestep_InvitationCodeNotFound"] = "Prestep_InvitationCodeNotFound";
  TranslationKey["Prestep_InvitationCodeTitle"] = "Prestep_InvitationCodeTitle";
  TranslationKey["Prestep_InvitationCodeTooltip"] = "Prestep_InvitationCodeTooltip";
  TranslationKey["Prestep_LegalNotice"] = "Prestep_LegalNotice";
  TranslationKey["Prestep_LegalNotice_PrivacyPolicy_Label"] = "Prestep_LegalNotice_PrivacyPolicy_Label";
  TranslationKey["Prestep_LegalNotice_TermsAndConditions_Label"] = "Prestep_LegalNotice_TermsAndConditions_Label";
  TranslationKey["Prestep_Or"] = "Prestep_Or";
  TranslationKey["Prestep_Password"] = "Prestep_Password";
  TranslationKey["Prestep_Phone"] = "Prestep_Phone";
  TranslationKey["Prestep_PhoneWithPrefix"] = "Prestep_PhoneWithPrefix";
  TranslationKey["Prestep_PlaceholderEmail"] = "Prestep_PlaceholderEmail";
  TranslationKey["Prestep_PlaceholderPassword"] = "Prestep_PlaceholderPassword";
  TranslationKey["Prestep_PlaceholderPhone"] = "Prestep_PlaceholderPhone";
  TranslationKey["Prestep_PlaceholderPhoneWithPrefix"] = "Prestep_PlaceholderPhoneWithPrefix";
  TranslationKey["Prestep_ReferralTitle"] = "Prestep_ReferralTitle";
  TranslationKey["Prestep_RegistrationFailed"] = "Prestep_RegistrationFailed";
  TranslationKey["Prestep_TooltipPhone"] = "Prestep_TooltipPhone";
  TranslationKey["Prestep_TooltipPhoneWithPrefix"] = "Prestep_TooltipPhoneWithPrefix";
  TranslationKey["Prestep_UnauthorizedAccess"] = "Prestep_UnauthorizedAccess";
  TranslationKey["PrimaryChannelSubmitButton"] = "PrimaryChannelSubmitButton";
  TranslationKey["PrivacyPolicy_Label"] = "PrivacyPolicy_Label";
  TranslationKey["PrivacyPolicy_Text"] = "PrivacyPolicy_Text";
  TranslationKey["Reseller"] = "Reseller";
  TranslationKey["SecondStep_BrandPartnerNumber"] = "SecondStep_BrandPartnerNumber";
  TranslationKey["SecondStep_Button"] = "SecondStep_Button";
  TranslationKey["SecondStep_Button_Find"] = "SecondStep_Button_Find";
  TranslationKey["SecondStep_Country"] = "SecondStep_Country";
  TranslationKey["SecondStep_FindTheBestBrandPartner"] = "SecondStep_FindTheBestBrandPartner";
  TranslationKey["SecondStep_FindTheBestBrandPartner_Tooltip"] = "SecondStep_FindTheBestBrandPartner_Tooltip";
  TranslationKey["SecondStep_Header"] = "SecondStep_Header";
  TranslationKey["SecondStep_HeresYourBrandPartner"] = "SecondStep_HeresYourBrandPartner";
  TranslationKey["SecondStep_IKnowaBrandPartner"] = "SecondStep_IKnowaBrandPartner";
  TranslationKey["SecondStep_SearchedAddress"] = "SecondStep_SearchedAddress";
  TranslationKey["SecondStep_Text"] = "SecondStep_Text";
  TranslationKey["SecondStep_YourAreConnected"] = "SecondStep_YourAreConnected";
  TranslationKey["SecondStep_YourZipCode"] = "SecondStep_YourZipCode";
  TranslationKey["SecondStep_YourZipCode_Tooltip"] = "SecondStep_YourZipCode_Tooltip";
  TranslationKey["SupportCenter"] = "SupportCenter";
  TranslationKey["TermsAndConditions"] = "TermsAndConditions";
  TranslationKey["TermsAndConditions_Label"] = "TermsAndConditions_Label";
  TranslationKey["ThirdStep_AddYourDocument"] = "ThirdStep_AddYourDocument";
  TranslationKey["ThirdStep_AdditionalIDCard_Header"] = "ThirdStep_AdditionalIDCard_Header";
  TranslationKey["ThirdStep_AdditionalIDCard_Text"] = "ThirdStep_AdditionalIDCard_Text";
  TranslationKey["ThirdStep_Button"] = "ThirdStep_Button";
  TranslationKey["ThirdStep_Button_Continue_Payment"] = "ThirdStep_Button_Continue_Payment";
  TranslationKey["ThirdStep_ChooseDocumentType"] = "ThirdStep_ChooseDocumentType";
  TranslationKey["ThirdStep_Confirmation1"] = "ThirdStep_Confirmation1";
  TranslationKey["ThirdStep_Confirmation2"] = "ThirdStep_Confirmation2";
  TranslationKey["ThirdStep_DocumentDetails"] = "ThirdStep_DocumentDetails";
  TranslationKey["ThirdStep_DocumentFileSize"] = "ThirdStep_DocumentFileSize";
  TranslationKey["ThirdStep_DocumentNumber"] = "ThirdStep_DocumentNumber";
  TranslationKey["ThirdStep_DocumentNumber_Tooltip"] = "ThirdStep_DocumentNumber_Tooltip";
  TranslationKey["ThirdStep_DocumentType"] = "ThirdStep_DocumentType";
  TranslationKey["ThirdStep_Documents_Header"] = "ThirdStep_Documents_Header";
  TranslationKey["ThirdStep_ExpirationDate"] = "ThirdStep_ExpirationDate";
  TranslationKey["ThirdStep_ExpirationDate_Tooltip"] = "ThirdStep_ExpirationDate_Tooltip";
  TranslationKey["ThirdStep_GeneralConditions"] = "ThirdStep_GeneralConditions";
  TranslationKey["ThirdStep_GeneralConditions_Text"] = "ThirdStep_GeneralConditions_Text";
  TranslationKey["ThirdStep_Header"] = "ThirdStep_Header";
  TranslationKey["ThirdStep_HeaderText"] = "ThirdStep_HeaderText";
  TranslationKey["ThirdStep_IDCard_Header"] = "ThirdStep_IDCard_Header";
  TranslationKey["ThirdStep_IDCard_Text"] = "ThirdStep_IDCard_Text";
  TranslationKey["ThirdStep_ImageGuidelines"] = "ThirdStep_ImageGuidelines";
  TranslationKey["ThirdStep_KYCDocument_Header"] = "ThirdStep_KYCDocument_Header";
  TranslationKey["ThirdStep_KYCDocument_Text"] = "ThirdStep_KYCDocument_Text";
  TranslationKey["ThirdStep_More"] = "ThirdStep_More";
  TranslationKey["ThirdStep_SelectFile"] = "ThirdStep_SelectFile";
  TranslationKey["ThirdStep_ShowLess"] = "ThirdStep_ShowLess";
  TranslationKey["ThirdStep_ShowMore"] = "ThirdStep_ShowMore";
  TranslationKey["ThirdStep_UploadDocument"] = "ThirdStep_UploadDocument";
  TranslationKey["ThirdStep_UploadDocumentText"] = "ThirdStep_UploadDocumentText";
  TranslationKey["ThirdStep_Your_Documents_Header"] = "ThirdStep_Your_Documents_Header";
  TranslationKey["ThirdStep_Your_Documents_Text"] = "ThirdStep_Your_Documents_Text";
  TranslationKey["Welcome_Button"] = "Welcome_Button";
  TranslationKey["Welcome_Header"] = "Welcome_Header";
  TranslationKey["Welcome_Text"] = "Welcome_Text";
  TranslationKey["addresResults"] = "addresResults";
  TranslationKey["addressSearch"] = "addressSearch";
  TranslationKey["addressSearchTooltip"] = "addressSearchTooltip";
  TranslationKey["addressSearchValidation"] = "addressSearchValidation";
  TranslationKey["area"] = "area";
  TranslationKey["area_Placeholder"] = "area_Placeholder";
  TranslationKey["area_Tooltip"] = "area_Tooltip";
  TranslationKey["back"] = "back";
  TranslationKey["birthDate_DoesntMatchUniqueId"] = "birthDate_DoesntMatchUniqueId";
  TranslationKey["birthDate_LegalRequirementsFailed"] = "birthDate_LegalRequirementsFailed";
  TranslationKey["birthDate_OutOfRange"] = "birthDate_OutOfRange";
  TranslationKey["cancel"] = "cancel";
  TranslationKey["cannotCreate"] = "cannotCreate";
  TranslationKey["cannotDelete"] = "cannotDelete";
  TranslationKey["cannotGetData"] = "cannotGetData";
  TranslationKey["cannotResend"] = "cannotResend";
  TranslationKey["cannotUpdate"] = "cannotUpdate";
  TranslationKey["cannotVerify"] = "cannotVerify";
  TranslationKey["cannotVerifyCaptcha"] = "cannotVerifyCaptcha";
  TranslationKey["city"] = "city";
  TranslationKey["city_Placeholder"] = "city_Placeholder";
  TranslationKey["confirm"] = "confirm";
  TranslationKey["confirmDocumentDelete"] = "confirmDocumentDelete";
  TranslationKey["country"] = "country";
  TranslationKey["country_Placeholder"] = "country_Placeholder";
  TranslationKey["customerServiceLinkLabel"] = "customerServiceLinkLabel";
  TranslationKey["customer_NotEligible"] = "customer_NotEligible";
  TranslationKey["customer_NotUnique"] = "customer_NotUnique";
  TranslationKey["delete"] = "delete";
  TranslationKey["delivery"] = "delivery";
  TranslationKey["delivery2"] = "delivery2";
  TranslationKey["delivery2_Placeholder"] = "delivery2_Placeholder";
  TranslationKey["delivery2_Tooltip"] = "delivery2_Tooltip";
  TranslationKey["delivery3"] = "delivery3";
  TranslationKey["delivery3_Placeholder"] = "delivery3_Placeholder";
  TranslationKey["delivery3_Tooltip"] = "delivery3_Tooltip";
  TranslationKey["delivery_Placeholder"] = "delivery_Placeholder";
  TranslationKey["delivery_Tooltip"] = "delivery_Tooltip";
  TranslationKey["district"] = "district";
  TranslationKey["district_Placeholder"] = "district_Placeholder";
  TranslationKey["document_ExpirationTooSoon"] = "document_ExpirationTooSoon";
  TranslationKey["errorOccured"] = "errorOccured";
  TranslationKey["fileTypeIsNotSupported"] = "fileTypeIsNotSupported";
  TranslationKey["genderLabelMan"] = "genderLabelMan";
  TranslationKey["genderLabelOther"] = "genderLabelOther";
  TranslationKey["genderLabelWoman"] = "genderLabelWoman";
  TranslationKey["hide"] = "hide";
  TranslationKey["history"] = "history";
  TranslationKey["locality"] = "locality";
  TranslationKey["locality_Placeholder"] = "locality_Placeholder";
  TranslationKey["loginLinkLabel"] = "loginLinkLabel";
  TranslationKey["noSuggestions"] = "noSuggestions";
  TranslationKey["optedOutOfSponsorSelect"] = "optedOutOfSponsorSelect";
  TranslationKey["orderHistory"] = "orderHistory";
  TranslationKey["oriflameApp"] = "oriflameApp";
  TranslationKey["oriflameAppInfo"] = "oriflameAppInfo";
  TranslationKey["passwordRequirementCharactersCount"] = "passwordRequirementCharactersCount";
  TranslationKey["passwordRequirementDigit"] = "passwordRequirementDigit";
  TranslationKey["passwordRequirementLetter"] = "passwordRequirementLetter";
  TranslationKey["passwordRequirementLowerCaseLetter"] = "passwordRequirementLowerCaseLetter";
  TranslationKey["passwordRequirementSpecialCharacter"] = "passwordRequirementSpecialCharacter";
  TranslationKey["passwordRequirementUpperCaseLetter"] = "passwordRequirementUpperCaseLetter";
  TranslationKey["province"] = "province";
  TranslationKey["province_Placeholder"] = "province_Placeholder";
  TranslationKey["readMore"] = "readMore";
  TranslationKey["region"] = "region";
  TranslationKey["region_Placeholder"] = "region_Placeholder";
  TranslationKey["resendInMinute"] = "resendInMinute";
  TranslationKey["searchForAnAddress"] = "searchForAnAddress";
  TranslationKey["selectFile"] = "selectFile";
  TranslationKey["selectedFileExceedsMaximumSize"] = "selectedFileExceedsMaximumSize";
  TranslationKey["showImage"] = "showImage";
  TranslationKey["stateApproved"] = "stateApproved";
  TranslationKey["statePending"] = "statePending";
  TranslationKey["stateRejected"] = "stateRejected";
  TranslationKey["stateUnknown"] = "stateUnknown";
  TranslationKey["streetAddress"] = "streetAddress";
  TranslationKey["streetAddressTooltip"] = "streetAddressTooltip";
  TranslationKey["streetAddress_Placeholder"] = "streetAddress_Placeholder";
  TranslationKey["successResend"] = "successResend";
  TranslationKey["termsAndConditions_Mandatory"] = "termsAndConditions_Mandatory";
  TranslationKey["titleContinueApp"] = "titleContinueApp";
  TranslationKey["uploadDone"] = "uploadDone";
  TranslationKey["uploading"] = "uploading";
  TranslationKey["validationBirthDateRegex"] = "validationBirthDateRegex";
  TranslationKey["validationDateRegex"] = "validationDateRegex";
  TranslationKey["validationEmailIsAlreadyUsed"] = "validationEmailIsAlreadyUsed";
  TranslationKey["validationEmailTerminatedCustomer"] = "validationEmailTerminatedCustomer";
  TranslationKey["validationLength"] = "validationLength";
  TranslationKey["validationMandatoryPropertyIsNull"] = "validationMandatoryPropertyIsNull";
  TranslationKey["validationMaxLength"] = "validationMaxLength";
  TranslationKey["validationMaxValue"] = "validationMaxValue";
  TranslationKey["validationMinLength"] = "validationMinLength";
  TranslationKey["validationMinValue"] = "validationMinValue";
  TranslationKey["validationRegex"] = "validationRegex";
  TranslationKey["validationRegexBirthDate"] = "validationRegexBirthDate";
  TranslationKey["validationRegexEmail"] = "validationRegexEmail";
  TranslationKey["validationRegexIdentityCardDateExpiration"] = "validationRegexIdentityCardDateExpiration";
  TranslationKey["validationRegexPhone"] = "validationRegexPhone";
  TranslationKey["validationRegexUniqueID"] = "validationRegexUniqueID";
  TranslationKey["validationRequired"] = "validationRequired";
  TranslationKey["validationUniqueAlias"] = "validationUniqueAlias";
  TranslationKey["validationUniqueBankAccount"] = "validationUniqueBankAccount";
  TranslationKey["validationUniqueCustomerAttribute"] = "validationUniqueCustomerAttribute";
  TranslationKey["validationUniqueDisplayName"] = "validationUniqueDisplayName";
  TranslationKey["validationUniquePhone"] = "validationUniquePhone";
  TranslationKey["validationUniqueTaxCode"] = "validationUniqueTaxCode";
  TranslationKey["validationUniqueTaxCode2"] = "validationUniqueTaxCode2";
  TranslationKey["validationUniqueUniqueId"] = "validationUniqueUniqueId";
  TranslationKey["validationValidConfirmationCode"] = "validationValidConfirmationCode";
  TranslationKey["validationValidOldPassword"] = "validationValidOldPassword";
  TranslationKey["validationValidPhone"] = "validationValidPhone";
  TranslationKey["validationValidSponsorNumber"] = "validationValidSponsorNumber";
  TranslationKey["validationValidUniqueId"] = "validationValidUniqueId";
  TranslationKey["validationXmlCharacters"] = "validationXmlCharacters";
  TranslationKey["warning"] = "warning";
  TranslationKey["zipcode"] = "zipcode";
  TranslationKey["zipcode_Placeholder"] = "zipcode_Placeholder";
  return TranslationKey;
}({});